import createElement from "../../../../../helpers/createElement";

class CustomConstraintsCellEditor {
	/** @type {HTMLElement} */
	guiElement;
	/** @type {HTMLInputElement} */
	baseInput;

	/**
	 * @param {import('ag-grid-community/dist/lib/interfaces/iCellEditor').ICellEditorParams} params
	 */
	init(params) {
		// noinspection JSUnresolvedReference
		/** @type {GanttWrapper.GanttWrapper} */
		const ganttInstance = params.ganttInstance;

		/** @type {GanttWrapper.Task} */
		const task = params.data;

		const textRepresentation = ganttInstance._getTaskConstraintTextRepresentation(task);

		this.guiElement = createElement(`
			<div
				role="presentation"
				class="ag-cell-editor ag-labeled ag-label-align-left ag-text-field ag-input-field"
				ref="eInput"
			>
                <div
                	ref="eWrapper"
                 	class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper d-flex align-items-stretch"
                 	role="presentation"
                >
                    <input
                    	ref="eInput"
                     	class="ag-input-field-input ag-text-field-input flex-grow-1"
                      	type="text"
                       	id="ag-550-input"
                        tabindex="0"
                     	aria-label="Input Editor"
                     	autocomplete="off"
                     	value="${textRepresentation}"
                    >
					<button
						class="btn btn-primary btn-sm display-modal-button"
					>
						<i class="mdi mdi-view-sequential mr-0" style="font-size: 1.5rem"></i>
					</button>
                </div>
            </div>
		`);


		this.guiElement.querySelector('.display-modal-button').addEventListener('click', () => {
			params.stopEditing(true);
			ganttInstance._showTaskConstraintsModal(task);
		})

		this.baseInput = this.guiElement.querySelector('input');
	}

	// after this component has been created and inserted into the grid
	// noinspection JSUnusedGlobalSymbols
	afterGuiAttached() {
		this.baseInput.focus();
	}

	// Mandatory - Return the DOM element of your editor, this is what the grid puts into the DOM
	// noinspection JSUnusedGlobalSymbols
	getGui() {
		return this.guiElement;
	};

	// Mandatory - Return the final value - called by the grid once after editing is complete
	// noinspection JSUnusedGlobalSymbols
	getValue() {
		return this.baseInput.value;
	};

	// Gets called once after initialised. If you return true, the editor will
	// appear in a popup, so is not constrained to the boundaries of the cell.
	// This is great if you want to, for example, provide you own custom dropdown list
	// for selection. Default is false (ie if you don't provide the method).
	// noinspection JSUnusedGlobalSymbols
	isPopup() {
		return false;
	};

	// Gets called once, only if isPopup() returns true. Return "over" if the
	// popup should cover the cell, or "under" if it should be positioned below
	// leaving the cell value visible. If this method is not present, the
	// default is "over"
	// noinspection JSUnusedGlobalSymbols
	getPopupPosition() {
		return 'over';
	};
}

export {CustomConstraintsCellEditor}
